<template>
  <el-dialog
    :title="$t('deleteChainInoutOrder.confirmTitle')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="handleClose">
    <div style="text-align:center">
      <p>{{ $t('deleteChainInoutOrder.confirmText') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">{{ $t('deleteChainInoutOrder.cancel') }}</el-button>
      <el-button type="primary" @click="confirmDelete">{{ $t('deleteChainInoutOrder.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteChainInoutOrder } from '@/api/goods/chainInoutOrderApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  data() {
    return {
      dialogVisible: false,
      deleteData: {
        orderId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.deleteData = {
        orderId: row.orderId,
        shopId: getShopId()
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.deleteData = {
        orderId: '',
        shopId: ''
      }
    },
    async confirmDelete() {
      try {
        await deleteChainInoutOrder(this.deleteData)
        this.$message.success(this.$t('deleteChainInoutOrder.deleteSuccess'))
        this.dialogVisible = false
        this.$emit('refresh')
      } catch (error) {
        console.error('删除失败:', error)
      }
    }
  }
}
</script>